<template>
  <iframe
    v-if="src"
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    allowfullscreen="true"
    :src="src"
    :style="{
      display: 'block',
      border: 'none',
      position: 'absolute',
      width: '100%',
      height: 'calc(100dvh - var(--nav-height) - 48px)'
    }"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      token: '',
      url: '',
      key: 1
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    src() {
      // https://localhost:3500

      if (!this.currentLang || !this.url || !this.token) return null

      let baseUrl = null
      if (window.location.hostname === 'localhost') {
        baseUrl = `http://localhost:3000/${this.currentLang}/iframe-dashboard/conversation?token=${this.token}`
      } else {
        baseUrl = `${this.url}/${this.currentLang}/iframe-dashboard/conversation?token=${this.token}`
      }
      return baseUrl
    }
  },
  watch: {
    selectedBot(data) {
      const tempToken = data.page_custom_attributes_json.amaze_token || null
      const tempUrl = data.page_custom_attributes_json.amaze_cms_url

      this.token = tempToken
      this.url = tempUrl
      this.key = this.key++
    }
  },
  async mounted() {
    await this.$store.dispatch('updateBotDetail')
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/amaze/DashboardAmazeConversationIframe.vue